import Vue from 'vue'
import App from './App.vue'
import "./assets/styles/index.scss"
import VantGreen from 'vant-green';
import 'vant-green/lib/index.css';

Vue.use(VantGreen);
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
